import React, { useContext } from 'react'

//styles
import './CardComponent.css'

import { Button, InputNumber, Tag } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { PokemonCard } from '../../Models/PokemonCard';
import { Inventary } from '../../Models/Inventary';
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import { Monitor } from '../../Models/Monitor';
import { addMonitor } from '../../Api/Monitor';
import Flag from 'react-world-flags';
import TagQuantityComponent from '../TagQuantityComponent/TagQuantityComponent';


interface Props{
    propsStyles?: React.CSSProperties,
    onClick?: (card:PokemonCard) => void
    onClickIventary?: (iventary:Inventary) => void

    elementClass?: string

    //functions props
    hasQty?: boolean
    hasCart?: boolean
    qtyFunction?: (qty:number, inventary:Inventary) => void
    maxQty?: number

    hasPrice?: boolean
    price?: number
    cashPrice?:number
    priceString?: string
    language?:string

    card:PokemonCard
    inventary?:Inventary
    type: string

}

const CardComponentPokemon = ({propsStyles, language,  onClick, elementClass, hasQty, qtyFunction, hasPrice, card, maxQty, inventary, priceString, price, onClickIventary, hasCart, type, cashPrice}:Props) => {
    const [qtyInput, setQtyInput] = React.useState<number>(0);
    const {cartCard, sendCartCard} = useContext(PromiseSesionContext);
    const {error, sendError} = useContext(PromiseSesionContext);
    
        const sendMonitor = async ()=>{
            try{let user:string= localStorage.getItem("user") || ""
  
            let monitor:Monitor={
                action:`Agrego al carrito: ${card.name} ${card.sets.name}`,
                user:user
            }
            await addMonitor(monitor)}
            catch(error){
 
            }
        }
        
    const addCart = ()=>{

      sendCartCard({type: "ADD", data:{producto:inventary}})
      sendError({type: "ERROR", data:{message:`${card.name} agregada al carrito`, type:"info"}})

    }
    const styles = {
        cursor: (onClick || onClickIventary) ? "pointer" : "" 
        ,
        ...propsStyles
      }

  return (
    <div onClick={()=>{onClick && onClick(card); (onClickIventary && inventary) && onClickIventary(inventary)}} className={'CardElement ' + (elementClass && elementClass)} style={styles}>
        <div className='CardElementBody'>

        <div className='CardElement-image'>
            <img src={card.imageUrl} alt='Logo'></img>

            <div className='CardElement-quantity'>
                <TagQuantityComponent quantity={inventary?.quantity || 0} />
            </div>

            <span className='CardElementType'>{type!="rare" ? type : "  "}</span>
            <div className='CardElement-flagSection'>
            {language==="EN" ? <Flag height="20" code={ "US"} style={{border:"1px solid #000" }}  /> : 
            language==="ES" ? <Flag height="20" code={ "ES"} style={{border:"1px solid #000" }}  />: 
            language==="FR" ? <Flag height="20" code={ "FR"} style={{border:"1px solid #000" }}  />: 
            <Flag height="20" code={ "VE"} style={{border:"1px solid #000" }}  />}
            </div>

            <div className='CardElemetSetImage'>
                <img src={card.sets.logoUrl} alt='Logo set'></img>
            </div>
        </div>

        <div className='CardElementInfo'>
            {/* <span>{inventary && inventary.quantity} {inventary && (inventary.quantity>1?` Disponibles` : ` Disponible`)}   </span> */}

            {/* {hasPrice && <span className='CardElementPrice'>${price || priceString} <span className='bcv-tag'>(BCV)</span></span>} */}
            
            <div className='productoCard-newPrice-section'>
            <div className='productCard-newPrice-block'>
                {hasPrice && <span className='productCard-newPrice-textBCV'>${price || priceString}</span>}
                 <Tag color='#DBDBDB' className='tag-bcv'>TASA BCV </Tag>
            </div>

            <div className='productCard-newPrice-divider'></div>
            <div className='productCard-newPrice-block'>
                <span className='productCard-newPrice-textCash'>${hasPrice && cashPrice}</span>

                {/* <span className='productCard-newPrice-textCash'>${producto.cash_price}</span> */}
                <Tag color='#007d0098' className='tag-cash'>Divisas</Tag>
            </div>
            

          </div>
        </div>
        </div>

        {hasQty && 
        <div className='CardElementQty'>
            <InputNumber className='CardElementQtyInput' min={0} value={qtyInput} max={maxQty} onChange={(e)=>{setQtyInput(e || 0)}} />
            <Button className='CardElementQtyButton' type='primary' onClick={() => (qtyFunction&& inventary) && qtyFunction(qtyInput, inventary)}><ShoppingCartOutlined /></Button>
        
        </div>
        }

        {hasCart && 
        <div className='CardElementAdd'>
            <button className='ProductCard-Button' style={{width:"100%"}}  onClick={() => {sendMonitor();addCart()}}> Agregar <ShoppingCartOutlined /></button>
        
        </div>
        }
    
    </div>
  )
}

export default CardComponentPokemon